module.exports = __webpack_public_path__ + "static/media/portal_bg.b5df8d1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portal_bg.png
// module id = 953
// module chunks = 0